import { createSelector } from '@reduxjs/toolkit'

interface CullingState {
  depth: number
}

interface GraphRootState {
  graph?: {
    culling?: CullingState
  }
}

const defaultCullingState: CullingState = {
  depth: 1,
}


const selectCulling = (state: Record<string, unknown>): CullingState => {
  const graph = (state as GraphRootState).graph
  return graph?.culling ?? defaultCullingState
}

export default createSelector(selectCulling, (culling) => culling.depth)
